<div class="statistic-panel">
  @if (!loading) {
    <span class="statistic">{{ statistics?.subjects?.toLocaleString() || 0 }}</span>
  }
  @if (!loading) {
    <span class="stat-label">Subjects</span>
  }
</div>
<div class="statistic-panel">
  @if (!loading) {
    <span class="statistic">{{ statistics?.sessions?.toLocaleString() || 0 }}</span>
  }
  @if (!loading) {
    <span class="stat-label">Sessions</span>
  }
</div>
<div class="statistic-panel">
  @if (!loading) {
    <span class="statistic">{{ statistics?.acquisitions?.toLocaleString() || 0 }}</span>
  }
  @if (!loading) {
    <span class="stat-label">Acquisitions</span>
  }
</div>
<div class="statistic-panel">
  @if (!loading) {
    <span class="statistic">{{ statistics?.acquisition_files?.toLocaleString() || 0 }}</span>
  }
  @if (!loading) {
    <span class="stat-label">Acquisition Files</span>
  }
</div>
<div class="statistic-panel">
  @if (!loading) {
    <span class="statistic">{{ statistics?.analyses?.toLocaleString() || 0 }}</span>
  }
  @if (!loading) {
    <span class="stat-label">Analyses</span>
  }
</div>
<div class="statistic-panel">
  @if (!loading) {
    <span class="statistic">{{ statistics?.jobs?.toLocaleString() || 0 }}</span>
  }
  @if (!loading) {
    <span class="stat-label">Jobs</span>
  }
</div>
